module.exports = "https://cdn2-fs.clearscore.com/flux/images/b3ca7b1cd144acb07feee3df976a0a34.jpg";